import React from "react";
import { DocTitle } from "@axl/accel-framework/components";
import { useInstance } from "react-ioc";
import { SchoolStore } from 'stores';

type SchoolDocTitleProps = {
    title: string,
}

const SchoolDocTitle: React.FC<SchoolDocTitleProps> = ({ title, children }) => {
    const store = useInstance(SchoolStore);
    return <DocTitle title={title} prefix={store.school.name} usePrefix={true} children={children} />;
}
export default SchoolDocTitle;